// SATX campus org chart. Entries reading ADD TEAM MEMBER are placeholders.

export const ORG = {
  root:{
    name:"Pastor Courtney Beard",
    role:"Senior Pastor & Founder"
  },
  exec:[
    {
      name:"Quinetta Beard",
      role:"Church Life Pastor | GLO Director",
      color:"purple",
      reports:[
        {
          name:"LaKita Parker",
          role:"GLO Lead — Women's Ministry"
        },
        {
          name:"Kesha Hawkins",
          role:"Experience Team Lead"
        }
      ]
    },
    {
      name:"Trestan Patton",
      role:"Campus Pastor",
      color:"blue",
      reports:[
        {
          name:"Cole Holmes",
          role:"Campus Security & Facilities Director",
          reports:[
            {
              name:"ADD TEAM MEMBER",
              role:"Security — edit in config"
            },
            {
              name:"ADD TEAM MEMBER",
              role:"Facilities — edit in config"
            }
          ]
        },
        {
          name:"Nadara Quintero & Terry",
          role:"Riot Haus — Student Ministry"
        }
      ]
    },
    {
      name:"Nicole Patton",
      role:"Kid Nation Director & Finance Lead",
      color:"green",
      reports:[
        {
          name:"Victoria Washington",
          role:"Kid Nation Lead"
        }
      ]
    },
    {
      name:"Meagan Rollerson",
      role:"Production Lead",
      color:"orange",
      reports:[
        {
          name:"Terry Gooch",
          role:"Asst. Production Lead"
        },
        {
          name:"Fabi Brascia",
          role:"Pre-Show Lead / LeVites"
        },
        {
          name:"George Brascia",
          role:"Audio Lead"
        }
      ]
    },
    {
      name:"Raquel Fulford",
      role:"Admin & Operations Lead",
      color:"red",
      reports:[
        {
          name:"Connect Team",
          role:"First-Time Visitor Outreach"
        },
        {
          name:"Service Flow Team",
          role:"Service Managers · Armorbearers · Live Host"
        }
      ]
    }
  ],
  ministry:[
    {
      name:"Jas Currie",
      role:"Worship Lead"
    },
    {
      name:"Will Rollerson",
      role:"Music Director"
    },
    {
      name:"Destiny Holmes",
      role:"Prayer Haus Lead"
    },
    {
      name:"Katie Williams",
      role:"Digital Content | Social Media Lead"
    }
  ],
  legend:[
    [
      "purple",
      "Church Life"
    ],
    [
      "blue",
      "Campus / Leadership"
    ],
    [
      "green",
      "Kid Nation / Finance"
    ],
    [
      "orange",
      "Production"
    ],
    [
      "red",
      "Admin / Ops"
    ],
    [
      "gold",
      "Ministry Leads"
    ]
  ]
};
